const View = require("presto-ui").baseView;
const dom = require("presto-ui").doms;

const LinearLayout = require("presto-ui").views.LinearLayout;
const ImageView = require("presto-ui").views.ImageView;
const TextView = require("presto-ui").views.TextView;

const Config = require('./../../globalConfig');
const Controller = require('./../../controller/pages/Mobile/MobileHome2');
const Strings = require('./../../res/string');
const Accessibility = require('./../../res/accessibility');
const Font = require('./../../res/fontStyle');
const Color = require('./../../res/color');
const FontSize = require('./../../res/fontSize');
const FontColor = require('./../../res/fontColor');

class MobileHome2 extends Controller {

	constructor(props, children, state) {
		super(props, children, state);
		this.STR = Strings();
		this.HINT = Accessibility();
	}

	onPop = () => {}

	render = () => {
		this.layout = (
			<LinearLayout
				id={this.id("Content")}
				height="match_parent"
				width="match_parent"
				orientation="vertical"
				gravity="center_horizontal"
				background={Color.A__FFFFFFFF}
				cornerRadius="0"
				root={true}
				style={this.style_Content}>
				<LinearLayout
					id={this.id("Header")}
					height="226"
					width="match_parent"
					orientation="vertical"
					gravity="center_horizontal"
					padding="30,31,30,0"
					background={Color.A__FFFFFFFF}
					cornerRadius="0"
					style={this.style_Header}>
					<ImageView
						id={this.id("Group_5")}
						height="33"
						width="match_parent"
						margin="10,0,10,0"
						imageUrl="group592"
						style={this.style_Group_5} />
					<TextView
						id={this.id("Register")}
						height="25"
						width="match_parent"
						margin="0,44,0,0"
						text={this.STR.Register1}
						textSize={FontSize.A_18}
						color={FontColor.A__FF3A3A3A}
						fontStyle={Font.AVENIR_ROMAN}
						gravity="left"
						style={this.style_Register} />
					<TextView
						id={this.id("Forum")}
						height="25"
						width="match_parent"
						margin="0,30,0,0"
						text={this.STR.Forum2}
						textSize={FontSize.A_18}
						color={FontColor.A__FF3A3A3A}
						fontStyle={Font.AVENIR_ROMAN}
						gravity="left"
						style={this.style_Forum} />
				</LinearLayout>
				<LinearLayout
					id={this.id("HeroGroup")}
					height="835"
					width="match_parent"
					orientation="vertical"
					gravity="center_horizontal"
					padding="20,0,20,0"
					background={Color.A__FFFFFFFF}
					cornerRadius="0"
					style={this.style_HeroGroup}>
					<TextView
						id={this.id("HeroHeaderText")}
						height="72"
						width="match_parent"
						text={this.STR.Hero_Epic75}
						textSize={FontSize.A_28}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_BLACK}
						lineHeight="36px"
						gravity="left"
						style={this.style_HeroHeaderText} />
					<ImageView
						id={this.id("JuspayVideo")}
						height="319"
						width="match_parent"
						margin="0,30,0,0"
						imageUrl="juspayvideo86"
						style={this.style_JuspayVideo} />
					<TextView
						id={this.id("HeroHelpText")}
						height="256"
						width="match_parent"
						margin="0,26,0,0"
						text={this.STR.Section_body76}
						textSize={FontSize.A_18}
						color={FontColor.A__FF3A3A3A}
						fontStyle={Font.ROBOTOMONO_REGULAR}
						lineHeight="32px"
						gravity="left"
						style={this.style_HeroHelpText} />
					<TextView
						id={this.id("LetsStartLink")}
						height="32"
						width="match_parent"
						margin="0,40,0,0"
						text={this.STR.Jump_in___get_starte77}
						textSize={FontSize.A_18}
						color={FontColor.A__FFEE0000}
						fontStyle={Font.ROBOTOMONO_BOLD}
						lineHeight="32px"
						gravity="left"
						style={this.style_LetsStartLink} />
				</LinearLayout>
				<LinearLayout
					id={this.id("PrestoSectionGroup")}
					height="1112"
					width="match_parent"
					orientation="vertical"
					gravity="center_horizontal"
					padding="0,60,0,0"
					background={Color.A__FFF7F7F7}
					cornerRadius="0"
					style={this.style_PrestoSectionGroup}>
					<TextView
						id={this.id("Presto_Section_Header")}
						height="108"
						width="match_parent"
						margin="20,0,20,0"
						text={this.STR.PrestoSectionText78}
						textSize={FontSize.A_24}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_BLACK}
						lineHeight="36px"
						gravity="center"
						style={this.style_Presto_Section_Header} />
					<TextView
						id={this.id("Hero_Story")}
						height="576"
						width="match_parent"
						margin="20,30,20,0"
						text={this.STR.Hero_Story90}
						textSize={FontSize.A_18}
						color={FontColor.A__FF3A3A3A}
						fontStyle={Font.ROBOTOMONO_REGULAR}
						lineHeight="32px"
						gravity="center"
						style={this.style_Hero_Story} />
					<ImageView
						id={this.id("BHIM_Logo")}
						height="18"
						width="90"
						margin="0,28,0,0"
						imageUrl="bhimlogo87"
						style={this.style_BHIM_Logo} />
					<TextView
						id={this.id("Hero_Story_Copy")}
						height="32"
						width="match_parent"
						margin="0,10,0,0"
						text={this.STR.Hero_Story_Copy91}
						textSize={FontSize.A_18}
						color={FontColor.A__FF3A3A3A}
						fontStyle={Font.AVENIR_ROMAN}
						lineHeight="32px"
						gravity="center"
						style={this.style_Hero_Story_Copy} />
					<ImageView
						id={this.id("Juspay_Safe")}
						height="22"
						width="124"
						margin="0,30,0,0"
						imageUrl="juspaysafe88"
						style={this.style_Juspay_Safe} />
					<TextView
						id={this.id("Hero_Story_Copy_2")}
						height="32"
						width="match_parent"
						margin="0,10,0,0"
						text={this.STR.Hero_Story_Copy_292}
						textSize={FontSize.A_18}
						color={FontColor.A__FF3A3A3A}
						fontStyle={Font.AVENIR_ROMAN}
						lineHeight="32px"
						gravity="center"
						style={this.style_Hero_Story_Copy_2} />
					<ImageView
						id={this.id("Logo")}
						height="23"
						width="74"
						margin="0,31,0,0"
						imageUrl="logo89"
						style={this.style_Logo} />
					<TextView
						id={this.id("Hero_Story_Copy_2100000000ø")}
						height="32"
						width="match_parent"
						margin="0,9,0,0"
						text={this.STR.Hero_Story_Copy_293}
						textSize={FontSize.A_18}
						color={FontColor.A__FF3A3A3A}
						fontStyle={Font.AVENIR_ROMAN}
						lineHeight="32px"
						gravity="center"
						style={this.style_Hero_Story_Copy_2100000000ø} />
				</LinearLayout>
				<LinearLayout
					id={this.id("WhatCourseSectionGroup")}
					height="1006"
					width="match_parent"
					orientation="vertical"
					padding="0,60,0,0"
					background={Color.A__FFFFFFFF}
					cornerRadius="0"
					style={this.style_WhatCourseSectionGroup}>
					<TextView
						id={this.id("PrestoSectionHeaderText")}
						height="72"
						width="320"
						margin="20,0,0,0"
						text={this.STR.WhatCourseText81}
						textSize={FontSize.A_24}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_BLACK}
						lineHeight="36px"
						gravity="center"
						style={this.style_PrestoSectionHeaderText} />
					<TextView
						id={this.id("CurriculumHeaderText")}
						height="33"
						width="match_parent"
						margin="0,50,0,0"
						text={this.STR.CurriculumText82}
						textSize={FontSize.A_24}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_ROMAN}
						gravity="center"
						style={this.style_CurriculumHeaderText} />
					<ImageView
						id={this.id("CurriculumIcon")}
						height="35"
						width="47"
						margin="157,19,0,0"
						imageUrl="curriculumicon90"
						style={this.style_CurriculumIcon} />
					<TextView
						id={this.id("CurriculumHelpText")}
						height="352"
						width="320"
						margin="20,30,0,0"
						text={this.STR.CurriculumHelpText83}
						textSize={FontSize.A_18}
						color={FontColor.A__FF3A3A3A}
						fontStyle={Font.ROBOTOMONO_REGULAR}
						lineHeight="32px"
						gravity="left"
						style={this.style_CurriculumHelpText} />
					<TextView
						id={this.id("ProjectHeaderText")}
						height="33"
						width="match_parent"
						margin="0,50,0,0"
						text={this.STR.Project31}
						textSize={FontSize.A_24}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_ROMAN}
						gravity="center"
						style={this.style_ProjectHeaderText} />
					<ImageView
						id={this.id("ProjectIcon")}
						height="35"
						width="35"
						margin="163,19,0,0"
						imageUrl="projecticon91"
						style={this.style_ProjectIcon} />
					<TextView
						id={this.id("PrjectHelpText")}
						height="128"
						width="320"
						margin="20,30,0,0"
						text={this.STR.ProjectHelpText84}
						textSize={FontSize.A_18}
						color={FontColor.A__FF3A3A3A}
						fontStyle={Font.ROBOTOMONO_REGULAR}
						lineHeight="32px"
						gravity="left"
						style={this.style_PrjectHelpText} />
				</LinearLayout>
				<LinearLayout
					id={this.id("FooterGroup")}
					height="320"
					width="match_parent"
					orientation="vertical"
					gravity="center_horizontal"
					padding="20,49,20,0"
					background={Color.A__FFEE0000}
					cornerRadius="0"
					style={this.style_FooterGroup}>
					<TextView
						id={this.id("SoundsText")}
						height="120"
						width="match_parent"
						text={this.STR.SoundsText94}
						textSize={FontSize.A_18}
						color={FontColor.A__FFFFFFFF}
						fontStyle={Font.ROBOTOMONO_BOLD}
						lineHeight="40px"
						gravity="left"
						style={this.style_SoundsText} />
					<LinearLayout
						id={this.id("LetsStartButton")}
						height="60"
						width="match_parent"
						orientation="vertical"
						padding="0,14,0,13"
						margin="0,40,0,0"
						background={Color.A__FFFFFFFF}
						cornerRadius="4"
						style={this.style_LetsStartButton}>
						<TextView
							id={this.id("Let_s_Start")}
							height="33"
							width="match_parent"
							text={this.STR.Let_s_Start95}
							textSize={FontSize.A_24}
							color={FontColor.A__FFEE0000}
							fontStyle={Font.AVENIR_HEAVY}
							gravity="center"
							style={this.style_Let_s_Start} />
					</LinearLayout>
				</LinearLayout>
			</LinearLayout>
		);
		this.containerId = this.layout.idSet.id;
		return this.layout.render();
	}

};

module.exports = MobileHome2;



// WEBPACK FOOTER //
// ./views/Mobile/MobileHome2.js